import React from 'react';

interface ProgressCircleProps {
  progress: number;
  goal: number;
  unit: string;
  size?: number;
  strokeWidth?: number;
  primaryColor?: string;
  secondaryColor?: string;
}

const ProgressCircle: React.FC<ProgressCircleProps> = ({
  progress,
  goal,
  unit,
  size = 200,
  strokeWidth = 15,
  primaryColor = '#5e35b1',
  secondaryColor = '#e0e0e0',
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progressPercent = Math.min(progress / goal, 1);
  const dashOffset = circumference * (1 - progressPercent);

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="transform -rotate-90">
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={secondaryColor}
            strokeWidth={strokeWidth}
          />
          {/* Progress circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={primaryColor}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            strokeLinecap="round"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <span className="text-5xl font-bold">{progress}</span>
          <span className="text-sm">{unit}</span>
        </div>

        <div className="flex flex-col items-center justify-center text-center">
          <span className="text-md mt-1">
            Time Left to Target:{' '}
            {goal - progress > 0 ? `${goal - progress} ${unit}` : `0 ${unit}`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressCircle;
